import React, {useEffect} from 'react';
import { BaseInput } from './BaseInput';
import { Input } from './styles';

export function FileInput({
  label = 'Label',
  renderBottomElement,
  placeholder = '',
  onChangeFile = () => {},
  ...props
}) {

  return (
    <BaseInput
      label={label}
      renderBottomElement={renderBottomElement}
      {...props}
    >
      <Input
        onChange={(e) => onChangeFile(e?.target?.files[0])}
        type="file"
        {...props}
      />
    </BaseInput>
  )
}